import React from "react";
import {
  Box, Typography, Grid, Card, CardActionArea, CardContent, Avatar
} from "@mui/material";
import AssessmentIcon from "@mui/icons-material/Assessment";
import SchoolIcon from "@mui/icons-material/School";
import EventIcon from "@mui/icons-material/Event";
import { useNavigate } from "react-router-dom";

const UTILITY = [
  {
    id: "report-if",
    label: "Report IF",
    descrizione: "Genera il report lezione completo (presenze + esito test) a partire da CSV Teams, elenco iscritti e risultati test LMS.",
    icon: <AssessmentIcon />,
    path: "/utility/report-if",
  },
  {
    id: "kpi-studenti",
    label: "KPI Studenti",
    descrizione: "KPI di presenza e apprendimento sui corsi di formazione: costanza, progressione dei quiz, esportazione XLSX e report visibile dai clienti.",
    icon: <SchoolIcon />,
    path: "/utility/kpi-studenti",
  },
  {
    id: "link-outlook",
    label: "Link calendario Outlook",
    descrizione: "Genera i link che aprono Outlook Web App con l'evento già compilato (oggetto, orari, link Teams), singolarmente o in blocco da Excel.",
    icon: <EventIcon />,
    path: "/utility/link-outlook",
  },
];

export default function UtilityHub() {
  const navigate = useNavigate();

  return (
    <Box>
      <Typography variant="h5" fontWeight="bold" mb={0.5}>Utility</Typography>
      <Typography variant="body2" color="text.secondary" mb={3}>
        Strumenti aggiuntivi, non legati a un singolo evento. Nuove funzionalità verranno aggiunte qui nel tempo.
      </Typography>

      <Grid container spacing={2}>
        {UTILITY.map((u) => (
          <Grid item xs={12} sm={6} md={4} key={u.id}>
            <Card elevation={1}>
              <CardActionArea onClick={() => navigate(u.path)} sx={{ p: 2, height: "100%" }}>
                <CardContent sx={{ p: 0 }}>
                  <Box display="flex" alignItems="center" gap={1.5} mb={1.5}>
                    <Avatar sx={{ backgroundColor: "#E6F1FB", color: "primary.main" }}>
                      {u.icon}
                    </Avatar>
                    <Typography variant="h6" fontWeight="bold">{u.label}</Typography>
                  </Box>
                  <Typography variant="body2" color="text.secondary">
                    {u.descrizione}
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
